import React from "react";

class LoadingChatIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputCounter: 0,
    };
  }

  // Use Effect?
  componentDidMount() {
    const intervalId = setInterval(() => {
        this.setState(e=>e.inputCounter = ((e.inputCounter + 1) % 4))
      }, 500);
  
    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }

  render() {
    return (
      <div style={{display: "inline-block"}}>
        <div style={{display:'flex'}}>
            <div style={{transition: "transform 0.4s",width: 30, height:30, backgroundColor:"#bababa", borderRadius: 20, marginRight: 5, transform: `scale(${this.state.inputCounter === 1? "1": "0.5"})`}}/>
            <div style={{transition: "transform 0.4s",width: 30, height:30, backgroundColor:"#bababa", borderRadius: 20, marginRight: 5, transform: `scale(${this.state.inputCounter === 2? "1": "0.5"})`}}/>
            <div style={{transition: "transform 0.4s",width: 30, height:30, backgroundColor:"#bababa", borderRadius: 20, marginRight: 5, transform: `scale(${this.state.inputCounter === 3? "1": "0.5"})`}}/>
        </div>
      </div>
    );
  }
}

export default LoadingChatIcon;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/LoadingChatIcon.jsx